(function () {
  'use strict';

  var activeModal   = null;
  var activeTrigger = null;

  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(', ');

  // ── Bootstrap ──────────────────────────────────────────────────────────────

  function init() {
    // Delegated: the trigger sits inside <variant-selects>, which is re-rendered on every variant change
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.size-chart__trigger');
      if (btn) onTriggerClick({ currentTarget: btn });
    });

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onKeyDown);
  }

  // ── Open ───────────────────────────────────────────────────────────────────

  function onTriggerClick(e) {
    var trigger = e.currentTarget;
    var modalId = trigger.getAttribute('aria-controls');
    var modal   = document.getElementById(modalId);
    if (!modal) return;
    openModal(modal, trigger);
  }

  function openModal(modal, trigger) {
    var pdfUrl = modal.getAttribute('data-pdf-url');
    var iframe = modal.querySelector('.size-chart-modal__iframe');
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    // Lazy-set iframe src on first open — avoids loading PDF until needed
    if (iframe && pdfUrl && !iframe.getAttribute('src')) {
      iframe.setAttribute('src', pdfUrl);
    }

    // Toggle aria-hidden on mobile fallback so screen readers see the link
    var fallback = modal.querySelector('.size-chart-modal__fallback');
    if (fallback) {
      fallback.setAttribute('aria-hidden', isMobile ? 'false' : 'true');
    }
    if (iframe) {
      iframe.setAttribute('aria-hidden', isMobile ? 'true' : 'false');
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('size-chart-open');

    activeModal   = modal;
    activeTrigger = trigger;

    // Move focus to close button
    requestAnimationFrame(function () {
      var closeBtn = modal.querySelector('.size-chart-modal__close');
      if (closeBtn) closeBtn.focus();
    });
  }

  // ── Close ──────────────────────────────────────────────────────────────────

  function closeModal() {
    if (!activeModal) return;

    activeModal.classList.remove('is-open');
    activeModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('size-chart-open');

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger.focus();
    }

    activeModal   = null;
    activeTrigger = null;
  }

  // ── Event handlers ─────────────────────────────────────────────────────────

  function onDocumentClick(e) {
    if (!activeModal) return;
    // Close if clicking overlay or any [data-size-chart-close] element
    if (e.target.closest('[data-size-chart-close]')) {
      closeModal();
    }
  }

  function onKeyDown(e) {
    if (!activeModal) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
      return;
    }

    // Focus trap — keep Tab cycling inside the dialog
    if (e.key === 'Tab') {
      var focusable = Array.from(
        activeModal.querySelectorAll(FOCUSABLE)
      ).filter(function (el) {
        // Exclude the invisible overlay from the tab cycle
        return !el.hasAttribute('data-size-chart-close') ||
               el.classList.contains('size-chart-modal__close');
      });

      if (!focusable.length) { e.preventDefault(); return; }

      var first = focusable[0];
      var last  = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  // ── Boot ───────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();